<template>
  <div class="data-update">
        <el-dialog :title="dataBulletin.id == 0?'新增':'修改'" :visible.sync="dialogFormVisible" style="text-align:left">
        <el-form 
            :model="dataBulletin" 
            label-width='80px' 
            ref="dataRef"
            @keyup.enter.native="submitData"
            :rules="formRules"
        >
            <el-form-item label="年度" label-width="120px" prop="time">
            <!-- <el-input 
                v-model="dataBulletin.timePeriod" 
                autocomplete="off"
            >
            </el-input> -->
             <el-date-picker
                v-model="year"
                type="year"
                value-format="yyyy"
                placeholder="选择年">
            </el-date-picker>
            <el-select v-model="season" clearable placeholder="请选择">
                <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.time"
                :value="item.id">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="数值" label-width="120px" prop="numericalValue">
            <el-input v-model="dataBulletin.numericalValue" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="销售额(亿元)" label-width="120px" prop="transaction">
            <el-input v-model="dataBulletin.transaction" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="描述" label-width="120px" prop="description">
            <el-input v-model="dataBulletin.description" autocomplete="off" type="textarea" rows="3"></el-input>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitData">确 定</el-button>
        </div>
        </el-dialog>
  </div>
</template>

<script>
export default {
    methods: {
        init(pid,id){
            if(this.$refs.dataRef){
                this.$nextTick(() => {
                this.$refs.dataRef.resetFields()
            })
            }
            console.log(1234)
            this.dialogFormVisible=true
            this.dataBulletin.id = id || 0;
            this.dataBulletin.pid = pid;
            if(this.dataBulletin.id){
                this.$ajaxGet(`/bulletin/open/showDataBulletin?id=${this.dataBulletin.id}`).then(({data}) => {
                    console.log(data,'详细信息')
                    if(data.code ===0){
                        this.dataBulletin = data.data
                    }
                })
            }
        this.descriptionlist()
        },
        descriptionlist(){
             this.$ajaxGet(`/bulletin/info/${this.dataBulletin.pid}`).then(({data}) => {
                    console.log(data,'详细信息')
                    if(data.code ===0){
                        this.dataBulletin.description = data.data.description
                    }
                })
        },
        //点击确定按钮
        submitData(){
            console.log(this.year,'年')
            console.log(this.season,'季度')
            this.dataBulletin.sort = this.year + this.season
            const season = this.options.find((item) => {
                return item.id == this.season
            })
            if(!this.year || !this.season){
                console.log(1111)
                this.$message({
                    type:'warning',
                    message:'请输入年度'
                })
                return
            }
            this.dataBulletin.timePeriod = this.year+'年' + season.time
            this.$refs.dataRef.validate(valid => {
                if(valid){
                    this.$ajaxPost(`/bulletin/${this.dataBulletin.id==0?'saveDataBulletin':'updateDataBulletin'}`,this.dataBulletin).then(({data}) => {
                        console.log(data,'新增或修改数据快报')
                        if(data.code===0){
                            this.$emit('dataListUpdate')
                            this.dialogFormVisible = false
                            this.$message.success('操作成功')
                        }       
                    })
                }
                else{
                    return false
                }
            })
        },
    },
    data() {
        return {
            formRules:{
                // time:[{required: true, message: '选择时间', trigger: 'blur' }],
                numericalValue:[{required: true, message: '请输入数值', trigger: 'blur' }],
                transaction:[{required: true, message: '请输入销售额', trigger: 'blur' }]
            },
            dialogFormVisible: false,
            //数据快报修改或添加参数
            dataBulletin:{
                timePeriod:'',
                // id:null,
                numericalValue:'',
                description:'',
                sort:'',
                transaction:'',//销售额
                pid:'',
                showStatus:1
            },
            options:[
                {id:'01',time:'第一季度'},
                {id:'02',time:'第二季度'},
                {id:'03',time:'第三季度'},
                {id:'04',time:'第四季度'}
            ],//第几季度
            year:'',
            season:''
        }
    },
}
</script>